import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import BaseLayer from "../core/BaseLayer";
import LineModels from "./models";
import { isVectorTile } from "../tile/utils";

var LineLayer = /*#__PURE__*/function (_BaseLayer) {
  _inherits(LineLayer, _BaseLayer);

  var _super = _createSuper(LineLayer);

  function LineLayer() {
    var _this;

    _classCallCheck(this, LineLayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "type", 'LineLayer');

    _defineProperty(_assertThisInitialized(_this), "arrowInsertCount", 0);

    _defineProperty(_assertThisInitialized(_this), "defaultSourceConfig", {
      data: [{
        lng1: 100,
        lat1: 30.0,
        lng2: 130,
        lat2: 30
      }],
      options: {
        parser: {
          type: 'json',
          x: 'lng1',
          y: 'lat1',
          x1: 'lng2',
          y1: 'lat2'
        }
      }
    });

    return _this;
  }

  _createClass(LineLayer, [{
    key: "buildModels",
    value: function buildModels() {
      var _this2 = this;

      var shape = this.getModelType();
      this.layerModel = new LineModels[shape](this);
      this.layerModel.initModels(function (models) {
        _this2.dispatchModelLoad(models);
      });
    }
  }, {
    key: "rebuildModels",
    value: function rebuildModels() {
      var _this3 = this;

      this.layerModel.buildModels(function (models) {
        _this3.dispatchModelLoad(models);
      });
    }
  }, {
    key: "getDefaultConfig",
    value: function getDefaultConfig() {
      var type = this.getModelType();
      var defaultConfig = {
        line: {},
        linearline: {},
        simple: {},
        wall: {},
        arc3d: {
          blend: 'additive'
        },
        arc: {
          blend: 'additive'
        },
        greatcircle: {
          blend: 'additive'
        },
        vectorline: {},
        tileLine: {},
        halfLine: {},
        earthArc3d: {}
      };
      return defaultConfig[type];
    }
  }, {
    key: "getModelType",
    value: function getModelType() {
      var _shapeAttribute$scale;

      if (this.layerType) {
        return this.layerType;
      }

      var parserType = this.layerSource.getParserType();

      if (isVectorTile(parserType)) {
        return 'vectorline';
      }

      var shapeAttribute = this.styleAttributeService.getLayerStyleAttribute('shape');
      var shape = shapeAttribute === null || shapeAttribute === void 0 ? void 0 : (_shapeAttribute$scale = shapeAttribute.scale) === null || _shapeAttribute$scale === void 0 ? void 0 : _shapeAttribute$scale.field;
      return shape || 'line';
    }
  }]);

  return LineLayer;
}(BaseLayer);

export { LineLayer as default };